import React from 'react';
import _ from 'underscore';
import { Form, Select } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  subtotal: 0,
  discount: 0,
  additional_charges: 0,
  ppn: null,
  ppnRp: 0,
  totalCharges: 0,
};

const ppnOptions = [
  { value: 11, label: '11 %' },
  { value: 1.1, label: '1.1 %' },
];

export const FormSubtotal = ({
  onChange,
  orders,
  data,
  isLoading
}) => {
  const [
    { subtotal, discount, additional_charges, ppn, ppnRp, totalCharges },
    setState,
  ] = React.useState(initialState);

  const $handleTotalCharges = async () => {
    const sda = (subtotal - discount) + additional_charges;
    let sdap = 0

    if (ppn) {
      sdap = sda * (ppn?.value / 100);
    }

    const tc = sda + sdap;

    setState((prevState) => ({
      ...prevState,
      totalCharges: tc,
      ppnRp: sdap,
    }));

    onChange({
      discount: discount,
      ppn: ppn?.value,
    });
  };

  React.useEffect(() => {
    let tot = 0;

    _.map(orders, function (ord) {
      tot += ord.total_charges;
    });

    setState((prevState) => ({
      ...prevState,
      subtotal: tot,
    }));
  }, [orders]);

  React.useEffect(() => {
    $handleTotalCharges();
  }, [subtotal, discount, ppn]);

  React.useEffect(() => {
    if (!data) return;
    const pn = data?.ppn === 11 ? ppnOptions[0]
    : data?.ppn === 1.1 ? ppnOptions[1] : null

    setState((prevState) => ({
      ...prevState,
      discount: data?.discount,
      additional_charges: data?.additional_charges,
      ppn: pn,
    }));
  }, [data]);

  return isLoading ? (
    <SkeletonsForm count={5} />
  ) : (
    <div className="mb-3 pt-3 ">
      <div className="hr-text hr-text-left text-primary mb-3">
        Biaya Penagihan
      </div>
      <div className="mb-3">
        <Form.Input value={subtotal} type="number" label="Subtotal" disabled />
      </div>
      <div className="mb-3">
        <Form.Input
          value={discount}
          onChange={(e) =>
            setState((prevState) => ({
              ...prevState,
              discount: e.target.valueNumber,
            }))
          }
          type="number"
          label="Diskon"
          disabled={subtotal <= 0}
        />
      </div>
      {data && (
        <div className='mb-3'>
          <Form.Input value={data?.additional_charges} type="number" label="Biaya Tambahan" disabled hint="Informasi biaya tambahan, dapat diinput dari informasi invoice" />
        </div>
      )}
      <div className="mb-3">
        <div className="row">
          <div className="col-6">
            <div className="form-label fs-8">
              PPN (%)
            </div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              value={ppn}
              initialValue={ppn}
              options={ppnOptions}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  ppn: e,
                }))
              }
            />
          </div>
          <div className="col-6">
            <Form.Input
              value={ppnRp}
              type="number"
              isPPn
              label="PPN (Rp)"
              disabled
            />
          </div>
        </div>
      </div>
      <div className="mb-3">
        <Form.Input
          value={totalCharges}
          type="number"
          label="Total Penagihan"
          disabled
        />
      </div>
    </div>
  );
};
